import { User } from '@src/main/modules/common/user/domain/User';
import { UserRepository } from '@src/main/modules/common/user/domain/UserRepository';

export const findUser = async (repository: UserRepository): Promise<User> =>
  await repository.findUser();
